// CocaAnnual1Slice - dedicated slice for COCA Annual Report 1, following MMT1Slice pattern
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../AxiosInterceptor/axiosInterceptor';
import { CocaByScenario } from '../../Table/TableQueryColumn';

const COCA_REPORTS_API_BASE = process.env.REACT_APP_COCAREPORTS;

const initialState = {
    COCAByScenarioData: {
        totalCount: 0,
        page: 0,
        pageSize: 50,
        collectionName: 'CocaByScenario',
        data: [],
        loading: false,
        error: false,
        lastRefreshedDate: ''
    }
};

// Thunk: fetch COCA Annual Report 1 details
export const getCocaAnnual1ReportData = createAsyncThunk('cocaAnnual1/getCocaAnnual1ReportData',
    async (_, { rejectWithValue }) => {
        try {
            let query = `query {GetCocaByScenarioDetails(\n    collectionName: "CocaByScenario"`;
            query += CocaByScenario; // fragment already closes braces

            const endpoint = COCA_REPORTS_API_BASE;
            if (!endpoint) {
                console.warn('[COCA Annual 1] REACT_APP_COCAREPORTS not set; request may fail');
            }

            const response = await axiosInstance.post(endpoint,
                JSON.stringify({ query, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const cocaAnnual1Slice = createSlice({
    name: 'cocaAnnual1',
    initialState,
    reducers: {
        clearData: (state) => {
            state.COCAByScenarioData = initialState.COCAByScenarioData;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCocaAnnual1ReportData.pending, (state) => {
                state.COCAByScenarioData.loading = true;
                state.COCAByScenarioData.error = false;
            })
            .addCase(getCocaAnnual1ReportData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.COCAByScenarioData.loading = false;
                state.COCAByScenarioData.error = false;

                // Extract result from GraphQL response
                const result = response?.data?.data?.GetCocaByScenarioDetails;
                if (result?.lastRefreshedDate) {
                    state.COCAByScenarioData.lastRefreshedDate = result.lastRefreshedDate;
                }

                // Map raw API data to maintain field consistency
                const rawData = result?.data || [];

                state.COCAByScenarioData.data = rawData.map((r, idx) => ({
                    id: idx + 1,
                    CarlStep: r.CarlStep || '',
                    CarlScenario: r.CarlScenario || '',
                    CarlFinalEvaluation: r.CarlFinalEvaluation || '',
                    CarlClinicalEval: r.CarlClinicalEval || '',
                    CarlQlEval: r.CarlQlEval || '',
                    AuthCount: typeof r.AuthCount === 'number' ? r.AuthCount : Number(r.AuthCount) || 0,
                    JobTimeStamp: r.JobTimeStamp || ''
                }));

                state.COCAByScenarioData.totalCount = state.COCAByScenarioData.data.length;
            })
            .addCase(getCocaAnnual1ReportData.rejected, (state) => {
                state.COCAByScenarioData.loading = false;
                state.COCAByScenarioData.error = true;
            });
    }
});

export const { clearData } = cocaAnnual1Slice.actions;
export default cocaAnnual1Slice.reducer;